import React from 'react';
import {
  Avatar,
  createAvatarProps,
  Typography,
} from '@usepepper/sprout-kit-ui';
import { createStyles } from '@/contexts/theme-context';
import { Pressable, View } from 'react-native';

export const ACCOUNT_LIST_ROW_MIN_HEIGHT = 64;

interface AccountListItemRowProps {
  lastFulfilledDisplay: string;
  onPress: () => void;
  restaurantName: string;
  /** Seeds the avatar color alongside the name. */
  restaurantUUID: string;
  subtitle: string;
}

/** Phone-tier account row; the desktop tier renders `AccountListTable` instead. */
export const AccountListItemRow: React.FC<AccountListItemRowProps> = ({
  lastFulfilledDisplay,
  onPress,
  restaurantName,
  restaurantUUID,
  subtitle,
}) => {
  const [styles, theme] = useStyles();
  const avatarProps = createAvatarProps(restaurantName, restaurantUUID);

  return (
    <Pressable
      accessibilityLabel={restaurantName}
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [styles.row, pressed && styles.rowPressed]}
    >
      <Avatar {...avatarProps} size="$md" />
      <View style={styles.textBlock}>
        <Typography numberOfLines={1} variant="label">
          {restaurantName}
        </Typography>
        <Typography
          color={theme.sk.color.text.secondary}
          fontSize="$sm"
          numberOfLines={1}
        >
          {subtitle}
        </Typography>
      </View>
      <Typography
        color={theme.sk.color.text.secondary}
        fontSize="$sm"
        numberOfLines={1}
        style={styles.fulfilledDate}
      >
        {lastFulfilledDisplay}
      </Typography>
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  fulfilledDate: {
    alignSelf: 'flex-start',
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceMedium,
    minHeight: ACCOUNT_LIST_ROW_MIN_HEIGHT,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  rowPressed: {
    backgroundColor: theme.sk.color.bg.primary.pressed,
  },
  textBlock: {
    flex: 1,
    gap: 2,
    minWidth: 0,
  },
}));
